import React, { useCallback, useState, lazy } from 'react';
import { motion } from 'framer-motion';
import { Play, CheckCircle2, Quote, User, Image as ImageIcon, ArrowRight } from 'lucide-react';
const LOGO_URL = 'https://mirrorful-production.s3.us-west-1.amazonaws.com/patterns/files/1fe96f6f-1f03-4364-8d80-26b79759d2dc/1RKo-p6JN8APdj7mGyenqGfyGF2jf9pbO.png';
const US_STATES = ['Alabama', 'Alaska', 'Arizona', 'Arkansas', 'California', 'Colorado', 'Connecticut', 'Delaware', 'Florida', 'Georgia', 'Hawaii', 'Idaho', 'Illinois', 'Indiana', 'Iowa', 'Kansas', 'Kentucky', 'Louisiana', 'Maine', 'Maryland', 'Massachusetts', 'Michigan', 'Minnesota', 'Mississippi', 'Missouri', 'Montana', 'Nebraska', 'Nevada', 'New Hampshire', 'New Jersey', 'New Mexico', 'New York', 'North Carolina', 'North Dakota', 'Ohio', 'Oklahoma', 'Oregon', 'Pennsylvania', 'Rhode Island', 'South Carolina', 'South Dakota', 'Tennessee', 'Texas', 'Utah', 'Vermont', 'Virginia', 'Washington', 'West Virginia', 'Wisconsin', 'Wyoming'];
const FadeIn = ({
  children,
  delay = 0,
  className = ''
}: {
  children: React.ReactNode;
  delay?: number;
  className?: string;
}) => <motion.div initial={{
  opacity: 0,
  y: 30
}} whileInView={{
  opacity: 1,
  y: 0
}} viewport={{
  once: true,
  margin: '-100px'
}} transition={{
  duration: 0.7,
  delay,
  ease: 'easeOut'
}} className={className} data-id="element-2">
    {children}
  </motion.div>;
export function LandingPage() {
  const [videoLoaded, setVideoLoaded] = useState(false);
  const loadVideo = useCallback(() => setVideoLoaded(true), []);
  const [formData, setFormData] = useState({
    nombre: '',
    email: '',
    telefono: '',
    estado: '',
    licencia: '',
    empresa: '',
    produccion: ''
  });
  const isFormValid = formData.nombre.trim() !== '' && formData.email.trim() !== '' && formData.telefono.trim() !== '' && formData.estado !== '' && formData.licencia !== '' && formData.produccion !== '';
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (isFormValid) {
      window.open('https://calendly.com/josephgh19/winners-mindset', '_blank', 'noopener,noreferrer');
    }
  };
  return <div className="min-h-screen bg-dark-bg text-white font-body selection:bg-magenta selection:text-white overflow-x-hidden" data-id="element-3">
      {/* Sticky Header */}
      <header className="fixed top-0 left-0 right-0 z-50 bg-dark-bg/80 backdrop-blur-lg border-b border-white/5" data-id="element-4">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-20 flex items-center justify-between" data-id="element-5">
          <img src={LOGO_URL} alt="Winners Mindset" className="h-10 w-auto" data-id="element-6" />
          <a href="#reserva" className="bg-magenta hover:bg-magenta/90 text-white font-bold py-2.5 px-6 rounded-lg transition-all hover:shadow-magenta-glow text-sm sm:text-base" data-id="element-7">
            Reservar Llamada
          </a>
        </div>
      </header>

      <main data-id="element-8">
        {/* Section 1: Hero */}
        <section className="pt-24 pb-6 px-4 sm:px-6 lg:px-8 max-w-7xl mx-auto text-center relative overflow-hidden" data-id="element-9">
          <div className="absolute top-1/4 left-1/2 -translate-x-1/2 w-[600px] h-[600px] bg-magenta/10 blur-[120px] rounded-full pointer-events-none" data-id="element-10"></div>

          <FadeIn className="relative z-10" data-id="element-11">
            <span className="inline-block bg-magenta/10 text-magenta border border-magenta/20 rounded-full px-5 py-2 text-sm font-semibold mb-4 tracking-wide uppercase" data-id="element-12">
              Invitación Privada para Agentes con Licencia
            </span>
            <h1 className="text-3xl md:text-4xl lg:text-5xl font-heading font-bold mb-3 leading-[1.1] tracking-tight" data-id="element-13">
              Agente con Licencia: <br className="hidden md:block" data-id="element-14" />
              <span className="text-transparent bg-clip-text bg-gradient-to-r from-white via-gray-200 to-gray-500" data-id="element-15">
                Mira Esto Antes de Elegir Tu Próximo Paso
              </span>
            </h1>
            <p className="text-lg md:text-xl text-[#CCCCCC] max-w-3xl mx-auto mb-6 font-light" data-id="element-16">
              Un sistema probado para producir más y hacer crecer tu agencia.
            </p>
          </FadeIn>

          <FadeIn delay={0.2} className="relative z-10" data-id="element-17">
            <div className="relative max-w-4xl mx-auto aspect-video rounded-2xl border border-white/10 shadow-magenta-glow overflow-hidden mb-6" data-id="element-18">
              {videoLoaded ? <iframe src="https://www.youtube-nocookie.com/embed/o_G7jHmNf04?rel=0&modestbranding=1&autoplay=1" title="Winners Mindset VSL" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen className="absolute inset-0 w-full h-full" data-id="element-19" /> : <button onClick={loadVideo} className="absolute inset-0 w-full h-full cursor-pointer group bg-black" aria-label="Reproducir video" data-id="element-20">
                  <img src="https://img.youtube.com/vi/o_G7jHmNf04/maxresdefault.jpg" alt="Video thumbnail" className="absolute inset-0 w-full h-full object-cover opacity-80 group-hover:opacity-100 transition-opacity" loading="eager" decoding="async" data-id="element-21" />
                  <div className="absolute inset-0 flex items-center justify-center" data-id="element-22">
                    <div className="bg-magenta/90 group-hover:bg-magenta w-16 h-16 md:w-20 md:h-20 rounded-full flex items-center justify-center transition-all group-hover:scale-110 shadow-lg" data-id="element-23">
                      <Play className="w-8 h-8 md:w-10 md:h-10 text-white ml-1" data-id="element-24" />
                    </div>
                  </div>
                </button>}
            </div>
          </FadeIn>

          <div className="relative z-10" data-id="element-25">
            <a href="#reserva" className="inline-flex items-center justify-center bg-magenta hover:bg-magenta/90 text-white font-bold text-base md:text-lg py-4 px-8 rounded-lg transition-all hover:shadow-magenta-glow hover:-translate-y-1" data-id="element-26">
              Reservar Llamada <ArrowRight className="ml-2 w-5 h-5" data-id="element-27" />
            </a>
          </div>
        </section>

        {/* Section 2: Value Proposition */}
        <section className="py-14 bg-dark-sec border-y border-white/5" data-id="element-28">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-29">
            <FadeIn data-id="element-30">
              <h2 className="text-4xl md:text-5xl lg:text-6xl font-heading font-bold text-center mb-12" data-id="element-31">
                Por Qué los Agentes Están Moviendo Su Negocio Aquí
              </h2>
            </FadeIn>

            <FadeIn delay={0.2} data-id="element-32">
              <ul className="max-w-xl mx-auto space-y-6" data-id="element-33">
                {['Sistema predecible de adquisición de clientes', 'Entrenamiento en vivo y mentoría recurrente', 'Camino profesional claro para construir una agencia', 'Compensación líder en la industria', 'Apoyo de productores con experiencia'].map((item, i) => <li key={i} className="flex items-center group" data-id="element-34">
                    <div className="bg-magenta/10 p-1 rounded-full mr-4 group-hover:bg-magenta/20 transition-colors" data-id="element-35">
                      <CheckCircle2 className="w-6 h-6 text-magenta shrink-0" data-id="element-36" />
                    </div>
                    <span className="text-xl text-gray-200 font-medium" data-id="element-37">
                      {item}
                    </span>
                  </li>)}
              </ul>
            </FadeIn>
          </div>
        </section>

        {/* Section 3: Social Proof */}
        <section className="py-14 bg-dark-bg" data-id="element-38">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-39">
            <FadeIn data-id="element-40">
              <h2 className="text-4xl md:text-5xl lg:text-6xl font-heading font-bold text-center mb-12" data-id="element-41">
                Agentes Ya Produciendo Dentro del Sistema
              </h2>
            </FadeIn>

            <div className="grid md:grid-cols-3 gap-8 mb-12" data-id="element-42">
              {[{
              name: 'Joshua Torrez',
              title: 'Dueño de Agencia',
              image: 'https://cdn.magicpatterns.com/uploads/1oo7dvZxVFhYqPm2tVaPjn/IMG_0324.jpg',
              quote: 'He estado en la industria por algunos años, pero desde que empecé a trabajar con Joseph y el equipo de Winners Mindset he tenido los mejores años de mi carrera. Aquí tenemos todo lo que necesitamos para tener éxito.'
            }, {
              name: 'Yasser Fermin',
              title: 'Dueño de Agencia',
              image: 'https://cdn.magicpatterns.com/uploads/uvarFJqf7DjJE4i8VXh7Q4/Screenshot_2026-03-12_at_11.00.05_AM.png',
              quote: 'He estado con Winners Mindset durante los últimos dos años. El año pasado me enfoqué en crecer mi negocio y aquí me dieron todas las herramientas y recursos para hacerlo. Hoy tenemos una agencia que sigue creciendo gracias al sistema y al apoyo de Winners Mindset.'
            }, {
              name: 'Joselyn Guzman',
              title: 'Insurance Broker',
              image: 'https://cdn.magicpatterns.com/uploads/tizu55pn2nhgTcydKw6kAQ/Screenshot_2026-03-12_at_11.01.52_AM.png',
              quote: 'Me conecté a todos los entrenamientos y empecé a aplicar las técnicas que enseñan. Mi mejor mes fue de $52,000 en producción y ahora no bajo de $30,000 al mes. Lo más impresionante es que yo no tenía experiencia previa en la industria.'
            }].map((testimonial, i) => <FadeIn key={i} delay={i * 0.15} data-id="element-43">
                  <div className="bg-dark-card rounded-2xl p-8 border-t-4 border-magenta relative shadow-lg hover:shadow-magenta-glow/50 transition-shadow duration-300 h-full flex flex-col" data-id="element-44">
                    <div className="flex items-center mb-8" data-id="element-45">
                      {testimonial.image ? <img src={testimonial.image} alt={testimonial.name} className="w-16 h-16 rounded-full border border-white/10 mr-5 shrink-0 object-cover" loading="lazy" decoding="async" width={64} height={64} data-id="element-46" /> : <div className="w-16 h-16 bg-dark-sec rounded-full border border-white/10 flex items-center justify-center mr-5 shrink-0" data-id="element-47">
                          <User className="w-8 h-8 text-gray-500" data-id="element-48" />
                        </div>}
                      <div data-id="element-49">
                        <h3 className="font-bold text-xl text-white" data-id="element-50">
                          {testimonial.name}
                        </h3>
                        {testimonial.title && <p className="text-magenta text-sm font-medium" data-id="element-51">
                            {testimonial.title}
                          </p>}
                      </div>
                    </div>
                    <p className="text-gray-300 italic text-lg leading-relaxed flex-1" data-id="element-52">
                      "{testimonial.quote}"
                    </p>
                  </div>
                </FadeIn>)}
            </div>
          </div>
        </section>

        {/* Section 4: Who is this for */}
        <section className="py-14 bg-dark-sec border-y border-white/5 relative overflow-hidden" data-id="element-53">
          <div className="absolute left-0 top-1/2 -translate-y-1/2 w-96 h-96 bg-magenta/5 blur-[100px] rounded-full pointer-events-none" data-id="element-54"></div>
          <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-55">
            <FadeIn data-id="element-56">
              <h2 className="text-4xl md:text-5xl lg:text-6xl font-heading font-bold text-center mb-12" data-id="element-57">
                Esto Es Para Agentes con Licencia Que Quieren
              </h2>
            </FadeIn>

            <div className="grid sm:grid-cols-2 gap-6 md:gap-8" data-id="element-58">
              {['Producir $10K–$20K+ al mes', 'Construir un negocio real de seguros', 'Eventualmente construir y liderar su propia agencia', 'Conectarse a un sistema probado para producción consistente'].map((item, i) => <FadeIn key={i} delay={i * 0.1} data-id="element-59">
                  <div className="bg-dark-card p-8 rounded-2xl border border-white/5 flex items-start h-full hover:border-magenta/30 transition-colors shadow-lg" data-id="element-60">
                    <div className="bg-magenta/10 p-2 rounded-lg mr-5 shrink-0" data-id="element-61">
                      <ArrowRight className="w-6 h-6 text-magenta" data-id="element-62" />
                    </div>
                    <span className="text-xl text-gray-200 font-medium leading-tight pt-1" data-id="element-63">
                      {item}
                    </span>
                  </div>
                </FadeIn>)}
            </div>
          </div>
        </section>

        {/* Section 5: Second CTA */}
        <section className="py-16 bg-dark-bg relative overflow-hidden" data-id="element-64">
          <div className="absolute inset-0 flex items-center justify-center pointer-events-none" data-id="element-65">
            <div className="w-[800px] h-[400px] bg-magenta/10 blur-[120px] rounded-full" data-id="element-66"></div>
          </div>
          <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center relative z-10" data-id="element-67">
            <FadeIn data-id="element-68">
              <p className="text-3xl md:text-4xl font-heading font-medium leading-tight mb-12 text-white/90" data-id="element-69">
                Si ya tienes licencia y quieres saber cómo funciona el sistema,
                reserva una llamada rápida con nuestro equipo de liderazgo.
              </p>
              <a href="#reserva" className="inline-flex items-center justify-center bg-magenta hover:bg-magenta/90 text-white font-bold text-xl py-5 px-12 rounded-lg transition-all hover:shadow-magenta-glow hover:-translate-y-1" data-id="element-70">
                Programa Tu Llamada <ArrowRight className="ml-3 w-6 h-6" data-id="element-71" />
              </a>
            </FadeIn>
          </div>
        </section>

        {/* Section 6: Booking Form */}
        <section id="reserva" className="py-14 bg-dark-card border-t border-white/5" data-id="element-72">
          <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-73">
            <FadeIn data-id="element-74">
              <div className="text-center mb-10" data-id="element-75">
                <h2 className="text-4xl md:text-5xl lg:text-6xl font-heading font-bold mb-6" data-id="element-76">
                  Reserva Tu Llamada
                </h2>
                <p className="text-[#CCCCCC] text-xl font-light" data-id="element-77">
                  Completa el formulario y nuestro equipo se pondrá en contacto
                  para programar tu llamada.
                </p>
              </div>

              <form className="space-y-6 bg-dark-bg p-8 md:p-10 rounded-3xl border border-white/10 shadow-2xl" onSubmit={handleSubmit} data-id="element-78">
                <div className="grid md:grid-cols-2 gap-6" data-id="element-79">
                  <div data-id="element-80">
                    <label className="block text-sm font-semibold text-gray-300 mb-2 uppercase tracking-wide" data-id="element-81">
                      Nombre Completo
                    </label>
                    <input type="text" value={formData.nombre} onChange={e => setFormData({
                    ...formData,
                    nombre: e.target.value
                  })} className="w-full bg-dark-sec border border-white/10 rounded-xl px-5 py-4 text-white focus:outline-none focus:border-magenta focus:ring-1 focus:ring-magenta transition-all placeholder:text-gray-600" placeholder="Tu nombre" required data-id="element-82" />
                  </div>
                  <div data-id="element-83">
                    <label className="block text-sm font-semibold text-gray-300 mb-2 uppercase tracking-wide" data-id="element-84">
                      Correo Electrónico
                    </label>
                    <input type="email" value={formData.email} onChange={e => setFormData({
                    ...formData,
                    email: e.target.value
                  })} className="w-full bg-dark-sec border border-white/10 rounded-xl px-5 py-4 text-white focus:outline-none focus:border-magenta focus:ring-1 focus:ring-magenta transition-all placeholder:text-gray-600" placeholder="tu@email.com" required data-id="element-85" />
                  </div>
                </div>

                <div data-id="element-86">
                  <label className="block text-sm font-semibold text-gray-300 mb-2 uppercase tracking-wide" data-id="element-87">
                    Número de Teléfono
                  </label>
                  <input type="tel" value={formData.telefono} onChange={e => setFormData({
                  ...formData,
                  telefono: e.target.value
                })} className="w-full bg-dark-sec border border-white/10 rounded-xl px-5 py-4 text-white focus:outline-none focus:border-magenta focus:ring-1 focus:ring-magenta transition-all placeholder:text-gray-600" placeholder="(555) 123-4567" required data-id="element-88" />
                </div>

                <div data-id="element-89">
                  <label className="block text-sm font-semibold text-gray-300 mb-2 uppercase tracking-wide" data-id="element-90">
                    Estado donde tienes licencia
                  </label>
                  <select value={formData.estado} onChange={e => setFormData({
                  ...formData,
                  estado: e.target.value
                })} className="w-full bg-dark-sec border border-white/10 rounded-xl px-5 py-4 text-white focus:outline-none focus:border-magenta focus:ring-1 focus:ring-magenta transition-all appearance-none cursor-pointer" required data-id="element-91">
                    <option value="" disabled data-id="element-92">
                      Selecciona un estado...
                    </option>
                    {US_STATES.map(state => <option key={state} value={state} data-id="element-93">
                        {state}
                      </option>)}
                  </select>
                </div>

                <div data-id="element-94">
                  <label className="block text-sm font-semibold text-gray-300 mb-2 uppercase tracking-wide" data-id="element-95">
                    ¿Tienes actualmente licencia para vender seguros de vida?
                  </label>
                  <select value={formData.licencia} onChange={e => setFormData({
                  ...formData,
                  licencia: e.target.value
                })} className="w-full bg-dark-sec border border-white/10 rounded-xl px-5 py-4 text-white focus:outline-none focus:border-magenta focus:ring-1 focus:ring-magenta transition-all appearance-none cursor-pointer" required data-id="element-96">
                    <option value="" disabled data-id="element-97">
                      Selecciona una opción...
                    </option>
                    <option value="active" data-id="element-98">Sí — Licencia Activa</option>
                    <option value="expired" data-id="element-99">Sí — Licencia Vencida</option>
                    <option value="none" data-id="element-100">No — Aún No Tengo Licencia</option>
                  </select>
                </div>

                <div data-id="element-101">
                  <label className="block text-sm font-semibold text-gray-300 mb-2 uppercase tracking-wide" data-id="element-102">
                    Empresa o Upline Actual
                  </label>
                  <input type="text" value={formData.empresa} onChange={e => setFormData({
                  ...formData,
                  empresa: e.target.value
                })} className="w-full bg-dark-sec border border-white/10 rounded-xl px-5 py-4 text-white focus:outline-none focus:border-magenta focus:ring-1 focus:ring-magenta transition-all placeholder:text-gray-600" placeholder="Nombre de la empresa" data-id="element-103" />
                </div>

                <div data-id="element-104">
                  <label className="block text-sm font-semibold text-gray-300 mb-2 uppercase tracking-wide" data-id="element-105">
                    Producción Mensual Aproximada
                  </label>
                  <select value={formData.produccion} onChange={e => setFormData({
                  ...formData,
                  produccion: e.target.value
                })} className="w-full bg-dark-sec border border-white/10 rounded-xl px-5 py-4 text-white focus:outline-none focus:border-magenta focus:ring-1 focus:ring-magenta transition-all appearance-none cursor-pointer" required data-id="element-106">
                    <option value="" disabled data-id="element-107">
                      Selecciona una opción...
                    </option>
                    <option value="0-2k" data-id="element-108">$0–$2K</option>
                    <option value="2k-5k" data-id="element-109">$2K–$5K</option>
                    <option value="5k-10k" data-id="element-110">$5K–$10K</option>
                    <option value="10k-20k" data-id="element-111">$10K–$20K</option>
                    <option value="20k+" data-id="element-112">$20K+</option>
                  </select>
                </div>

                <button type="submit" disabled={!isFormValid} className={`w-full font-bold text-xl py-5 px-8 rounded-xl transition-all mt-8 flex items-center justify-center ${isFormValid ? 'bg-magenta hover:bg-magenta/90 text-white hover:shadow-magenta-glow cursor-pointer' : 'bg-magenta/40 text-white/50 cursor-not-allowed'}`} data-id="element-113">
                  Programar Mi Llamada <ArrowRight className="ml-2 w-5 h-5" data-id="element-114" />
                </button>

                <p className="text-sm text-gray-500 text-center mt-6 font-light" data-id="element-115">
                  Al enviar este formulario, consientes ser contactado por
                  Winners Mindset sobre oportunidades de carrera.
                </p>
              </form>
            </FadeIn>
          </div>
        </section>
      </main>

      {/* Footer */}
      <footer className="bg-dark-bg py-16 border-t border-white/5" data-id="element-116">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex flex-col items-center" data-id="element-117">
          <img src={LOGO_URL} alt="Winners Mindset" className="h-10 w-auto mb-8 opacity-60 hover:opacity-100 transition-opacity" loading="lazy" decoding="async" data-id="element-118" />
          <p className="text-gray-500 text-sm font-light" data-id="element-119">
            © 2025 Winners Mindset. Todos los derechos reservados.
          </p>
        </div>
      </footer>
    </div>;
}